import API from './core/API'

const URL_BASE = window.location.origin
const URL_DEV = URL_BASE + '/dev/ajax-webpack/public/api.php/'
const URL_PROD = URL_BASE + '/api/api.php/'
const NEW_RESOURCE = 0

const tfApi = {
  /**
   * Constante indiquant qu'il s'agit d'une nouvelle ressource
   */
  NEW_RESOURCE: NEW_RESOURCE,
  URL: '',

  init: function(options) {
    this.URL = options.env === 'production' ? URL_PROD : URL_DEV
    const _options = {
      url: this.URL
    }
    localStorage.setItem('tfApi', JSON.stringify(_options))
  },

  /**
   * Récupération une ressource
   * @param {string} path
   */
  get: async function(path) {
    if (!path) {
      throw new Error('path is missing')
    }
    let ref = null
    try {
      ref = await API.get(this.URL + path)
    } catch (e) {
      console.error(e)
    }

    return ref
  },

  /**
   * Création d'une ressource
   * @param {string} path
   * @param {object} resource
   */
  set: async function(path, resource) {
    if (!path) {
      throw new Error('path is missing')
    }
    if (!resource) {
      throw new Error('resource is missing')
    }
    try {
      await API.set(this.URL + path, resource)
    } catch (e) {
      console.error(e)
    }

    return true
  },

  /**
   * Modification d'une ressource
   * @param {string} path
   * @param {object} ressource
   */
  update: async function(path, resource) {
    if (!path) {
      throw new Error('path is missing')
    }
    if (!resource) {
      throw new Error('resource is missing')
    }
    try {
      await API.update(this.URL + path, resource)
    } catch (e) {
      console.error(e)
    }

    return true
  },

  /**
   * Suppression d'une ressource
   * @param {string} path
   */
  delete: async function(path) {
    if (!path) {
      throw new Error('path is missing')
    }
    try {
      await API.delete(this.URL + path)
    } catch (e) {
      console.error(e)
    }

    return true
  },

  /**
   * Création/Modification d'une resource
   * @param {string} path
   * @param {object} resource
   */
  setOrUpdate: async function(path, resource) {
    if (!path) {
      throw new Error('path is missing')
    }
    if (!resource) {
      throw new Error('resource is missing')
    }
    if (resource.id === null || resource.id === undefined) {
      throw new Error('resource.id is missing')
    }
    try {
      if (resource.id === this.NEW_RESOURCE) {
        resource.id = await API.set(this.URL + path, resource)
      } else {
        await API.update(this.URL + path + '/' + resource.id, resource)
      }
    } catch (e) {
      console.error(e)
    }

    return resource
  }
}

export default tfApi
